import components from './components'
import edit from './edit'
import config from './config'
import helpers from './helpers'

const components3 = {
    components,
    edit,
    config,
    helpers
}

export default components3;